import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type InputNumber from './input-number.vue'

import type { InputNumberProps as AInputNumberProps } from 'ant-design-vue'

type Integer =
  | 'int8'
  | 'int16'
  | 'int32'
  | 'int64'
  | 'uint8'
  | 'uint16'
  | 'uint32'
  | 'uint64'
  | null

export const inputNumberProps = buildProps({
  value: {
    type: definePropType<AInputNumberProps['value']>([Number, String]),
    default: '',
  },
  // 是否显示中文大小金额
  isAmountChinese: {
    type: Boolean,
    default: false,
  },
  integer: {
    type: definePropType<Integer>(String),
    default: null,
  },
  // 后置单位标签
  unit: {
    type: String,
    default: '',
  },
  //  是否灰色样式
  isGray: {
    type: Boolean,
    default: false,
  },
})

export const inputNumberEmits = {
  change: (value: number) => !!value || typeof value === 'number',
  'update:value': (value: number) => !!value || typeof value === 'number',
} as const

// props
export type InputNumberProps = ExtractPropTypes<typeof inputNumberProps>

// emits
export type InputNumberEmits = typeof inputNumberEmits

// instance
export type InputNumberInstance = InstanceType<typeof InputNumber>
